import styled from '@emotion/styled'
import Head from 'next/head'
import Image from 'next/image'
import { Themed } from 'theme-ui'

import { useRouter } from 'next/router'
import { Container } from '../components/UIComponents'
import { mottagningenEnglishLocale, mottagningenSwedishLocale } from '../locales'

/**
 * Renders the Mottagningen component.
 *
 * @returns {HTMLElement} - The HTML Markup.
 */
const Mottagningen = () => {
  const router = useRouter()
  const { locale } = router
  const t = locale === 'en' ? mottagningenEnglishLocale : mottagningenSwedishLocale

  return (
    <>
      <Head>
        <title>Mottagningen - JC Psykologmottagning AB</title>
        <meta
          name="Description"
          // content="På mottagningen bedriver jag PDT- samt KBT-behandling med sjukvårdstaxa och högkostnadsskydd efter remiss från husläkare för personer från och med 16 år."
          content="På mottagningen bedriver KBT-behandling med sjukvårdstaxa och högkostnadsskydd efter remiss från husläkare för personer från och med 16 år."
        />
        <link rel="icon" href="/img/logo.svg" />
      </Head>
      <Container>
        <MottagningenStyles>
          <div className="col-md-4">
            <Themed.h1>{t.headingOne}</Themed.h1>
            <Themed.p>{t.paragraphOne}</Themed.p>
            <Themed.h2>{t.headingTwo}</Themed.h2>
            <Themed.p>{t.paragraphTwo}</Themed.p>
            <Themed.p>{t.paragraphThree}</Themed.p>
          </div>

          {/* KBT */}
          <div className="col-md-5">
            <Themed.h4>{t.headingThree}</Themed.h4>
            <Themed.p>{t.paragraphFour}</Themed.p>
            <Themed.p>{t.paragraphFive}</Themed.p>
            <Themed.p>{t.paragraphSix}</Themed.p>
          </div>
          {/* PDT */}
          {/* <div className="col-md-5">
            <Themed.h4>{t.pdtHeading}</Themed.h4>
            <Themed.p>{t.pdtParagraphOne}</Themed.p>
            <Themed.p>{t.pdtParagraphTwo}</Themed.p>
            <Themed.p>{t.pdtParagraphThree}</Themed.p>
          </div> */}
          <Themed.div className="col-md-3 center">
            <Image
              src="/img/mottagningen.jpg"
              className="fadein"
              alt="Mottagningen"
              width={240}
              height={320}
              priority={true}
            />
          </Themed.div>
        </MottagningenStyles>
      </Container>
    </>
  )
}

const MottagningenStyles = styled.section`
  p a {
    color: black;
    text-decoration: none;
  }
`

export default Mottagningen
